import FlowConfigBase from '#client/config/FlowConfigBase';
import * as ROUTES from '#client/constants/routes';

import PAGES, { PAGE_KEYS } from '../flowPageConfig';

export default FlowConfigBase.createEntry({
  id: 'beneficial-ownership-information',
  pageKeys: [
    PAGE_KEYS.BUSINESS_INFO_BOI,
    PAGE_KEYS.CONTACT_INFO,
    PAGE_KEYS.BOI,
    PAGE_KEYS.CHECKOUT,
    PAGE_KEYS.CONCLUSION
  ],
  pageConfigs: {
    [PAGES.BOI.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          secondaryAction: { onClick: null }
        }
      }
    },
    [PAGES.CHECKOUT.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          businessCardProps: {
            businessInfoFields: {
              businessName: {
                disabled: true
              }
            }
          }
        }
      }
    },
    [PAGES.CONTACT_INFO.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          calloutAsset: { name: 'boi-funnel-info' },
          pageHeader: { messageKey: 'contactInfoBOI' }
        }
      }
    },
    [PAGES.CONCLUSION.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          calloutAsset: { name: 'boi-funnel-conclusion' },
          nextSteps: {
            messageKey: 'shopping.page.conclusionBOI',
            activeStep: 3,
            stepsCount: 4,
            primaryAction: {
              href: ROUTES.UJM_COMPLETE_BOI
            }
          },
          pageHeader: {
            hideBack: true,
            messageKey: 'shopping.page.conclusionBOI'
          }
        }
      }
    }
  },
  autoLoadBusiness: true,
  authRedirect: ROUTES.DASHBOARD_BOI,
  entityType: 'llc',
  isPrimary: true,
  postOrderAutoLogin: true,
  postOrderRedirect: `${ROUTES.SHOP_BOI}/${PAGES.CONCLUSION.path}`,
  priceListUuids: {
    development: '4ad59ba1-3d64-4ae4-bb24-4722c2f55933',
    production: '774a97b7-8be1-46ab-bfc8-3172900e7576'
  }
});
